import { render, staticRenderFns } from "./ps-label-value.vue?vue&type=template&id=d16c0010&scoped=true"
import script from "./ps-label-value.vue?vue&type=script&lang=js"
export * from "./ps-label-value.vue?vue&type=script&lang=js"
import style0 from "./ps-label-value.vue?vue&type=style&index=0&id=d16c0010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16c0010",
  null
  
)

export default component.exports